import React from 'react'
import Filtro from '../../comum/Filtro'
import FiltrosAdicionadosUsuariosPlataformas from './FiltrosAdicionadosUsuariosPlataformas'
import FiltroUsuariosPlataformas from './FiltroUsuariosPlataformas'
import PainelFiltragem from '../../comum/PainelFiltragem'

export const PainelFiltrosUsuarioPlataformas = () => (
  <Filtro PainelFiltro={FiltroUsuariosPlataformas}/>
);

const PainelFiltrosUsuariosPlataformas = () => (
  <PainelFiltragem
    Filtro={PainelFiltrosUsuarioPlataformas}
    FiltrosAdicionados={FiltrosAdicionadosUsuariosPlataformas}/>
)

export default PainelFiltrosUsuariosPlataformas
